<template>
  <div class="nav_menu">
    <nav class="nav navbar-nav">
          <ul class=" navbar-right">
            <li class="nav-item float-left">
              <a class="user-profile" href="/sale">
                <i class="fa fa-dashboard mr-2"></i>{{$t('menu.dashboard')}}
              </a>
            </li>
            <li :class="show ? 'nav-item dropdown open show' : 'nav-item dropdown open'" style="padding-left: 15px;"
                v-on:click="showProfile()">
              <a href="javascript:;" class="user-profile dropdown-toggle" aria-haspopup="true" id="navbarDropdown"
                 data-toggle="dropdown" aria-expanded="false">
                {{$t('label.hello')}} {{$store.getters.fullName}}
              </a>
              <div
                :class="show ? 'dropdown-menu dropdown-usermenu pull-right show' : 'dropdown-menu dropdown-usermenu pull-right'"
                aria-labelledby="navbarDropdown">
                <a class="dropdown-item" href="javascript:void(0)" v-on:click="goToProfile()">
                  <i class="fa fa-user pull-right"></i>{{$t('label.profile')}}
                </a>
                <a class="dropdown-item" href="javascript:void(0)" v-on:click="goToHistory()">
                  <i class="fa fa-phone-square pull-right"></i>{{$t('label.callHistory')}}
                </a>
			          <a class="dropdown-item" href="javascript:void(0)" v-on:click="goToSummary()">
                  <i class="fa fa-file pull-right"></i>{{$t('label.summary')}}
                </a>
                <!-- <a class="dropdown-item" href="javascript:void(0)" v-on:click="goToNotes()">
                  <i class="fa fa-pencil pull-right"></i> Ghi chú
                </a> -->
                <a class="dropdown-item" href="javascript:void(0)" v-on:click="signOut()">
                  <i class="fa fa-sign-out pull-right"></i>{{$t('label.logOut')}}
                </a>
              </div>
            </li>
          </ul>
        </nav>
  </div>
</template>

<script>
  import apiClient from '@/axios'

  export default {
    name: 'MenuTopHeaderSale',
    data() {
      return {
        show: false,
        userInfo: {}
      }
    },
    mounted() {
      let body = document.getElementById('app');
      body.addEventListener('click', this.clickOnBody)
    },
    methods: {
      showProfile() {
        this.show = !this.show;
        event.stopPropagation();
      },
      clickOnBody() {
        this.show = false;
      },
      signOut() {
        this.$store.commit("doLogout")
        this.$router.push("/login")
      },
	  goToProfile() {
	    this.$router.replace("/sale/profile")
	  },
	  goToSummary() {
	    this.$router.replace("/sale/summary")
	  },
	  goToHistory() {
	    this.$router.replace("/sale/history")
	  },
     goToNotes() {
	    this.$router.replace("/sale/notes")
	  }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
  .sale {
    a:hover{
      color: $primary
    }
    .navbar-nav{
      width 100%
    }
    .container{
      max-width: 1140px;
    }
  }
</style>
